export default {
  'financeReconciliation.pageTitle': '财务对账',
  'financeReconciliation.bankAccount': '银行账户',
  'financeReconciliation.accountPeriod': '账期',
  'financeReconciliation.exportStatement': '导出账单',
  'financeReconciliation.monthlyStatement': '月度对账单',
  'financeReconciliation.statementPeriod': '账单周期',
  'financeReconciliation.opening': '期初余额',
  'financeReconciliation.credit': '本期收入',
  'financeReconciliation.debit': '本期支出',
  'financeReconciliation.closing': '期末余额',
  'financeReconciliation.transactionDate': '交易日期',
  'financeReconciliation.description': '摘要/对方户名',
  'financeReconciliation.debitOut': '支出 (OUT)',
  'financeReconciliation.creditIn': '收入 (IN)',
  'financeReconciliation.balance': '余额 (BAL)',
  'financeReconciliation.totalSummary': 'TOTAL SUMMARY',
  'financeReconciliation.createdTime': '制表时间',
  'financeReconciliation.poweredBy': 'Powered by SmartReconcile',
  'financeReconciliation.selectBankAccount': '请选择银行账户',
  'financeReconciliation.selectAccountPeriod': '请选择账期',
};
